import { APIModel, DisplayableType } from "../../api-model";
import { AssociatedUser } from "../../associated-user";

const STATUS_LABELS: Record<string, string> = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  verified: 'Verified'
}

export class ChecklistApplication extends APIModel {
  id!: string;
  checklist_started_at!: DisplayableType;
  verification_notes!: string;
  verified_at!: DisplayableType;
  verified_by_id!: string;
  match_id!: string;
  verified_by!: AssociatedUser;
  status!: string;
  checklist_name!: string;

  static fieldsToMap = {
    direct: [
      'id',
      'status',
      'checklist_started_at',
      'verified_at',
      'verification_notes',
      'verified_by_id',
      'checklist_name'
    ],
    formatDateTimeET: [
      'checklist_started_at',
      'verified_at'
    ],
  }

  get status_display(): string {
    return STATUS_LABELS[this.status] || this.status || 'Not Started';
  }

  static buildFromAPI(record: any): ChecklistApplication {
    const row = new ChecklistApplication();
    record = record || {};

    this.mapFieldsDirectly<ChecklistApplication>(ChecklistApplication.fieldsToMap.direct, record, row);
    this.mapFormatDateTimeET<ChecklistApplication>(ChecklistApplication.fieldsToMap.formatDateTimeET, record, row);

    row.verified_by = AssociatedUser.buildFromAPI(record.verified_by);
    row.verified_by.full_name = row.verified_by.full_name || 'N/A';

    return row
  }
}